import { useClients } from './useClients';

export function useClient(clientId: string | undefined | null, options?: { enabled?: boolean }) {
  const query = useClients({ enabled: options?.enabled });

  return {
    ...query,
    data: query.data?.data.clients.find((client) => client.id === clientId),
  };
}
